import React from 'react';
import {Query} from 'react-apollo'
import moment from 'moment'
import {Link} from "react-router-dom"

import Loading from '../Loading'

import QUERY from '../../../queries/server/new_projects'

const NewProjects = (props) => {
  return (
    <Query query={QUERY} fetchPolicy="network-only">
      {({loading, error, data}) => {

        if (loading) return <Loading />

        if (!data.new_projects.length) {
          return (
            <div className="d-flex align-items-center justify-content-center">
              <span className="lead">No new projects in last 7 days</span>
            </div>
          )
        }

        return (
            <div className="d-flex flex-column">
              {data.new_projects.map(project => (
                  <div className="d-flex flex-column border-bottom p-3">
                    <Link to={`/projects/${project.project_id}`}>
                      <span className="lead">{project.project_id} - {project.name}</span>
                    </Link>
                    {project.clients_as_string && <small>For: {project.clients_as_string}</small>}
                    <small>Status: {project.project_status.description}</small>
                    <small>Added: {moment(project.date_created).format('Do MMM YY')}</small>
                  </div>
              ))}
            </div>
        )
      }}
    </Query>
  )
}

export default NewProjects
